module.exports = __webpack_public_path__ + "static/img/Harry-Souttar.516fcf9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Harry-Souttar.jpg
// module id = dpWL
// module chunks = 0